import { baseApi, baseApiSearch } from 'components/constants/Constants';
import { request } from '../api';

export const ProductDetailsBySearchApi = (
  old_key,
  eventKey,
  success,
  handleError
) => {
  const options = {
    method: 'GET',
    url: `${baseApiSearch}/search/${eventKey}/products/${old_key}`,
    headers: { 'Content-Type': 'application/json' }
  };

  request(options, success, handleError);
};

export const findByKey = (company, segment, product, success, handleError) => {
  const options = {
    method: 'GET',
    url: `${baseApi}/companies/${company}/segments/${segment}/products/${product}`,
    headers: { 'Content-Type': 'application/json' }
  };
  request(options, success, handleError, handleError);
};

export const create = (product, success, handleError) => {
  const options = {
    method: 'POST',
    url: `${baseApi}/companies/${product.company.key}/segments/${product.segment}/products`,
    headers: { 'Content-Type': 'application/json' },
    data: product
  };

  request(options, success, handleError);
};

export const update = (product, success, handleError, signal) => {
  const options = {
    method: 'PUT',
    url: `${baseApi}/companies/${product.company.key}/segments/${product.segment}/products/${product.key}`,
    headers: { 'Content-Type': 'application/json' },
    data: product
  };

  request(signal ? { ...options, signal } : options, success, handleError);
};

export const loadProductAssets = (product, success, handleError) => {
  const options = {
    method: 'GET',
    url: `${baseApi}/companies/${product.company.key}/segments/${product.segment}/products/${product.key}/assets`,
    headers: { 'Content-Type': 'application/json' }
  };

  request(options, success, handleError);
};
export const downloadProductPublicAsset = (asset, success, handleError) => {
  const options = {
    method: 'GET',
    url: `${baseApiSearch}/public/assets/${asset.key}/download`,
    responseType: 'blob'
  };
  request(options, success, handleError);
};
export const downloadProductAsset = (product, asset, success, handleError) => {
  const options = {
    method: 'GET',
    url: `${baseApi}/companies/${product.company.key}/segments/${product.segment}/products/${product.key}/assets/${asset.key}/download`,
    responseType: 'blob'
  };

  request(options, success, handleError);
};

export const updateProductAsset = (product, asset, success, handleError) => {
  const options = {
    method: 'PUT',
    url: `${baseApi}/companies/${product.company.key}/segments/${product.segment}/products/${product.key}/assets/${asset.key}`,
    data: asset
  };

  request(options, success, handleError);
};

export const deleteProductAsset = (product, asset, success, handleError) => {
  const options = {
    method: 'DELETE',
    url: `${baseApi}/companies/${product.company.key}/segments/${product.segment}/products/${product.key}/assets/${asset.key}`
  };

  request(options, success, handleError);
};

export const uploadProductAsset = (
  product,
  asset,
  file,
  success,
  handleError
) => {
  let data = new FormData();
  data.append(
    'asset',
    new Blob([JSON.stringify(asset)], { type: 'application/json' })
  );
  data.append('content', file);

  const options = {
    method: 'POST',
    url: `${baseApi}/companies/${product.company.key}/segments/${product.segment}/products/${product.key}/assets`,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: data
  };

  request(options, success, handleError);
};

export const trash = (product, success, handleError, abortSignal) => {
  const options = {
    method: 'POST',
    url: `${baseApi}/companies/${product.company.key}/segments/${product.segment}/products/${product.key}/trash`,
    headers: { 'Content-Type': 'application/json' }
  };

  request(
    abortSignal ? { ...options, signal: abortSignal } : options,
    success,
    handleError
  );
};

export const unTrash = (product, success, handleError, abortSignal) => {
  const options = {
    method: 'POST',
    url: `${baseApi}/companies/${product.company.key}/segments/${product.segment}/products/${product.key}/untrash`,
    headers: { 'Content-Type': 'application/json' }
  };

  request(
    abortSignal ? { ...options, signal: abortSignal } : options,
    success,
    handleError
  );
};
